// extracted by mini-css-extract-plugin
export default {"main":"SectionList_main__GpR67"};